import { createAsyncThunk, createSlice, Slice } from '@reduxjs/toolkit'
import { PLAN } from 'src/lib/api-routes'

import { GetPlanParams, PlanType } from '../../types/plan.interface'
import { getPlan } from '../actions/get-plan'

export interface IPlan {
  data: PlanType | null
  error: string | null
  loading: boolean
}

export const initialState: IPlan = {
  data: null,
  error: null,
  loading: false,
}

export const getPlanAction = createAsyncThunk(
  PLAN,
  async (params: GetPlanParams) => {
    return (await getPlan(params))?.data as PlanType
  }
)

export const GetPlanSlice: Slice<IPlan> = createSlice({
  extraReducers: (builder) => {
    builder
      .addCase(getPlanAction.pending, (state) => {
        state.error = null
        state.loading = true
      })
      .addCase(getPlanAction.fulfilled, (state, action) => {
        state.data = action.payload
        state.error = null
        state.loading = false
      })
      .addCase(getPlanAction.rejected, (state, action) => {
        state.error = action.error.message ?? 'Error fetching plans'
        state.loading = false
      })
  },
  initialState,
  name: 'getPlan',
  reducers: {
    resetPlanData: (state) => {
      state.data = null
      state.error = null
      state.loading = false
    },
  },
})

export const { resetPlanData } = GetPlanSlice.actions
